export default __webpack_public_path__ + "media/images/celeste_dark_sit_-99a245b2527038a6113d23bb35a4047c.png";